import { useGetAuthConfigQuery } from '@/api/rysApi';
import type { AuthConfig } from '@/api/config';

/** Fetches /api/config/auth (RTK Query dedupes + caches across the app). */
export function useAuthConfig(): AuthConfig | null {
  const { data } = useGetAuthConfigQuery();
  return data ?? null;
}
